module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/arrow-up-7949dd6208090d15c06b4f2ef4a42d21.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/arrow-up.svg
// module id = A1D8
// module chunks = 24